// src/guards/RequireAuth.tsx
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AuthContext } from '../_services/firebase'

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { currentUser } = React.useContext(AuthContext)
  const location = useLocation()

  if (currentUser === null) {
    return <Navigate to='/login' state={{ from: location.pathname }} replace />
  }
  return <>{children}</>
}
